import React, { FC } from 'react';
import { ClickAwayListener, MenuList, Paper, styled, Theme } from '@material-ui/core';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import CustomMenuListItem from './CustomMenuListItem';
import { CustomMenuItem } from 'src/config/api/models/CustomMenu';

type Props = {
  onClose: (event?: React.MouseEvent<EventTarget>) => void;
  menuItemsList: CustomMenuItem[];
  variant: 'primary' | 'secondary';
  customWidth?: number;
};

const StyledPaper = styled(Paper)<
  Theme,
  { stylevariant?: 'primary' | 'secondary'; customWidth?: number }
>(({ theme, stylevariant = 'primary', customWidth }) => ({
  overflow: 'hidden',
  position: 'absolute',
  // maxWidth: '400px',
  top: -'2rem',
  transform: `translateX(${stylevariant === 'primary' ? '-100%' : '-100%'})`,
  width: stylevariant === 'secondary' ? `${customWidth ? customWidth + 'px' : 'auto'}` : 'auto',
  borderRadius: 10,
  /* TODO 2405 - add #B6B0A3 to theme colors*/
  border: stylevariant === 'primary' ? '1px solid gray' : '1px solid #B6B0A3',
  '& .custom-menu-list-item': {
    borderBottom: stylevariant === 'primary' ? '1px solid gray' : '1px solid #B6B0A3',
  },
  '& .custom-menu-list-item:nth-last-child(1 of .custom-menu-list-item)': {
    borderBottom: 'none',
  },
}));

const CustomMenuListPopup: FC<Props> = ({
  onClose,
  menuItemsList,
  variant = 'primary',
  customWidth,
}) => {
  const { getPath } = useI18nPath();

  return (
    <StyledPaper stylevariant={variant} customWidth={customWidth} id="menu-list-grow">
      <ClickAwayListener onClickAway={onClose}>
        <MenuList className="custom-menu-list">
          {menuItemsList.map((entry: CustomMenuItem, index) => (
            <CustomMenuListItem
              key={`customMenuList-${index}?`}
              label={entry.label}
              path={entry.to ? getPath(entry.to, entry.params) : undefined}
              icon={entry.icon}
              onClick={(event) => {
                entry.onClick && entry.onClick(event);
                onClose();
              }}
              className="custom-menu-list-item"
            />
          ))}
        </MenuList>
      </ClickAwayListener>
    </StyledPaper>
  );
};

export default CustomMenuListPopup;
